"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToFormProps({ data, forms }) {
    const form = 'blockType' in data ? data.formReference : data;
    if (!form || typeof form !== 'object' || 'formGuid' in form === false) {
        return {
            formId: null,
            heading: null,
            subheading: null,
            disclaimer: null,
            disclaimerPosition: null,
        };
    }
    const rawText = form?.disclaimers &&
        typeof form.disclaimers === 'object' &&
        'brandyRaw' in form.disclaimers &&
        typeof form.disclaimers.brandyRaw === 'string'
        ? form.disclaimers.brandyRaw
        : null;
    const emilyForm = forms && forms[form.formGuid];
    return {
        fields: emilyForm?.formFields,
        heading: form.heading,
        subheading: form.subheading,
        tcpaCheckbox: form?.tcpaCheckbox,
        disclaimer: {
            brandy: rawText,
        },
        disclaimerPosition: form.formDisclaimerPosition,
        formName: emilyForm?.name || null
    };
}
exports.default = mapToFormProps;
